export default "__VITE_ASSET__3605f2f8__"